var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1369 0.46967C11.9963 0.329018 11.8055 0.25 11.6066 0.25C11.4077 0.25 11.2169 0.329018 11.0763 0.46967L1.88388 9.66206C1.78965 9.75628 1.72223 9.87391 1.68856 10.0028L0.688556 13.8313C0.621266 14.0889 0.695605 14.3629 0.88388 14.5511C1.07215 14.7394 1.34614 14.8138 1.60375 14.7465L5.43218 13.7465C5.56111 13.7128 5.67874 13.6454 5.77297 13.5511L14.9654 4.35876C15.2582 4.06586 15.2582 3.59099 14.9654 3.2981L12.1369 0.46967ZM3.08843 10.5788L11.6066 2.06066L13.3744 3.82843L4.8562 12.3466L2.46344 12.9716L3.08843 10.5788Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.25C0.585786 16.25 0.25 16.5858 0.25 17C0.25 17.4142 0.585786 17.75 1 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H1Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.acb69575359622c2facc4115add1dd16.svg";
export { ForwardRef as ReactComponent };